<div class="body">
  <div class="container h-screen w-screen flex align-items-center justify-content-center text-center">
    <div class="right-column">
      <div>
        <img src="logo.png" alt="Logo" class="logo" width="128">
        <h2>RECUPERO PASSWORD</h2>


        <form #form='ngForm' class="login-form mb-3 fluid flex-column text-center"
              (ngSubmit)="recoverPassword()"
              *ngIf="!sentEmail">
          <p class="mb-4">{{ translations.auth.recoverPasswordInfo | translate }}</p>
          <div class="field">
            <div class="circle">
              <i class="fa fa-envelope"></i>
            </div>
            <input pInputText name="email" type="email"
                   autocomplete="off"
                   [placeholder]="translations.auth.email | translate" required
                   class="inputfield w-full"
                   [(ngModel)]="email">
          </div>
          <button pButton pRipple type="submit" class="" [disabled]="loading"
                  [label]="(!loading
                  ? translations.auth.recoverPassword
                  : translations.auth.loading) | translate"
          ></button>
        </form>
        <p *ngIf="sentEmail">
          {{ translations.auth.emailSentCheckInbox | translate }}
        </p>

        <br>

        <a pButton pRipple class="p-button-text" [href]="RoutingConstants.login">
          {{ translations.auth.loginQuestion | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
